<template>
  <div class="home">
    <home-swiper :home-banner="Banner"></home-swiper>
    <home-content :home-service="Service"></home-content>
    <el-image :src="'http://'+ HomePro.photoList[0].address" v-if="HomePro.photoList"
              class="home-image"
              fit="cover"
    ></el-image>
    <home-select :home-honor="Honor"></home-select>
    <home-case :home-case="Case"></home-case>
    <home-news :home-news="News"></home-news>
    <home-choose></home-choose>
  </div>
</template>

<script>

import HomeSwiper from "./banner";
import HomeContent from "./content/home";
import HomeSelect from "./HomeSelect";
import HomeCase from "@/views/Home/HomeCase/HomeCase";
import HomeNews from "@/views/Home/HomeNews/HomeNews";
import HomeChoose from "@/views/Home/HomeChoose";
export default {
  name: 'Home',
  data(){
    return{
      Banner:{},
      Service:{},
      Honor:{},
      HomePro:{},
      Case:{},
      News:{}
    }
  },
  components: {
    HomeChoose,
    HomeNews,
    HomeCase,
    HomeSelect,
    HomeContent,
    HomeSwiper,
  },
  created() {
    this.GetHomeData()
  },
  methods:{
    GetHomeData(){
      this.$axios.get('/api/photo/getBuildHomePage').then(res=>{
        this.Banner=res.data.data[0];
        this.Service=res.data.data[1];
        this.HomePro=res.data.data[2];
        this.Honor=res.data.data[3];
        this.Case=res.data.data[4];
        this.News=res.data.data[5];
        console.log(res);
      })
    }
  },
}
</script>
<style  lang="less" scoped>
  .home{
    width: 100%;
    min-width: 1024px;
    .home-image{
      width: 100%;
      height: 550px;
    }
  }
</style>
